import { createFileRoute } from "@tanstack/react-router";
import { PartnerShell } from "../../../features/partner/components/partner-shell";
import { PartnerHelpPage } from "../../../features/partner/pages/partner-help-page";

/** `/{lang}/partner/help`: WhatsApp and three short answers. */
export const Route = createFileRoute("/$lang/_partner/partner/help")({
  component: PartnerHelpRoute,
});

function PartnerHelpRoute() {
  const { lang } = Route.useParams();
  const search = Route.useSearch();
  return (
    <PartnerShell lang={lang} search={search} tab="help">
      <PartnerHelpPage />
    </PartnerShell>
  );
}
